<template>
	<div style="background-color: #f7f7f7; margin-top: 150px;margin-bottom: 35px;" >
		<!-- <div style="width: 100%;background-color: #fff;height: auto;">
			<div style="width: 1140px;min-width: 1140px;height: 81px;margin: auto;">
				<div style="float: left;    height: 81px;line-height: 81px;">
					<img src="../images/dialogImg1.png" alt=""><img src="../images/logoTitle.png"/>
				</div>

			</div>
		</div> -->
		<div style="width: 100%;min-width: 1700px;background-color: #f7f7f7;height: 750px;">
			<div class="register">
				<div style="display: inline-block;width: 400px;height: 750px;float: left;">
					<img src="../images/registerImg.png" style="width: 400px;height: 100%;" alt="">
				</div>
				<div style="display: inline-block;float: left;width: 740px;margin-top: 30px;">
          <div style="display: flex">

					<div style="color: #150e52;font-size: 33px;margin-bottom: 30px;text-align: center;width: 370px;cursor: pointer" @click="showWechatQrCode(true)">微信登录</div>
          <div style="color: #150e52;font-size: 33px;margin-bottom: 30px;text-align: center;width: 370px;cursor: pointer" @click="showWechatQrCode(false)">帐号登录</div>
          </div>
<!--          <div  v-show="wechatQrCode" style="text-align: center;margin-top: 100px">{{this.miniQrCode}}</div>-->
<!--          <vue-qr :logoSrc="" :text="miniQrCode" :size="200"></vue-qr>-->
          <div v-if="qrStatus">
          <vue-qr :text="miniQrCode" :size="350" v-if="wechatQrCode" style="text-align: center;margin-top: 50px;margin-left: 200px"></vue-qr>
          </div>
          <div v-if="!qrStatus&&wechatQrCode">
            二维码过期，请刷新页面重试
          </div>
          <div v-if="wechatQrCode" style="color: #150e52;font-size: 20px;width: auto;text-align: center" >手机打开微信“扫一扫”，扫码登录</div>

<!--          {{this.miniQrCode}}-->
          <el-form :model="loginForm" status-icon :rules="rules" ref="registerForm" label-width="100px" class="registerForm" v-show="!wechatQrCode" style="margin-top: 100px">
<!--            <el-form-item label="手机号码：" prop="phoneNumber">-->
<!--              &lt;!&ndash; <label slot="label">邮&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;箱：</label> &ndash;&gt;-->
<!--              <el-input type="text" v-model="loginForm.phoneNumber" autocomplete="off" placeholder="请输入手机号码"></el-input>-->
<!--            </el-form-item>-->
						<el-form-item label="帐号：" prop="userName">
							 <label slot="label">帐号/手机号：</label>
						  <el-input type="text" v-model="loginForm.userName" autocomplete="off" placeholder="输入帐号"></el-input>
						</el-form-item>
<!--						<el-form-item label="邮箱：" prop="email">-->
<!--							 <label slot="label">邮&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;箱：</label>-->
<!--						  <el-input type="text" v-model="registerForm.email" autocomplete="off" placeholder="输入邮箱"></el-input>-->
<!--						</el-form-item>-->
					  <el-form-item label="密码" prop="password">
						  <label slot="label">密&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;码：</label>
					    <el-input show-password type="password" v-model="loginForm.password" autocomplete="off" placeholder="密码为6-20个字符"></el-input>
					  </el-form-item>
            <el-form-item prop="code" >
              <label slot="label">验&nbsp;&nbsp;&nbsp;证&nbsp;&nbsp;&nbsp;码：</label>
              <el-input
                  v-model="loginForm.code"
                  auto-complete="off"
                  placeholder="验证码"
                  style="width: 63%"
                  @keyup.enter.native="handleLogin"
              >
                <svg-icon slot="prefix" icon-class="validCode" class="el-input__icon input-icon" />
              </el-input>
              <div class="login-code" style="margin-top: 20px;margin-left: 75px">
                <img :src="codeUrl" @click="getCode" class="login-code-img"/>
              </div>
            </el-form-item>
<!--					  <el-form-item label="确认密码：" prop="checkPass">-->
<!--					    <el-input show-password type="password" v-model="registerForm.checkPass" autocomplete="off"   placeholder="请重复输入密码"></el-input>-->
<!--					  </el-form-item>-->

<!--					 <el-form-item label="企业名称：" prop="firmName">-->
<!--					 	 &lt;!&ndash; <label slot="label">邮&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;箱：</label> &ndash;&gt;-->
<!--					   <el-input type="text" v-model="registerForm.firmName" autocomplete="off" placeholder="填写营业执照上注册的企业"></el-input>-->
<!--					 </el-form-item>-->
					 <div style="text-align: center;margin-top: 50px;">
						 <el-checkbox v-model="loginForm.checked">我已阅读并同意</el-checkbox>
						 <span class="yhxy" style="color: #150e52;font-size: 23px;cursor: pointer;">《用户服务协议》</span>
					 </div>

					  <el-form-item style="text-align: center;" class="btn">
					    <el-button  @click="submitForm('loginForm')" >立即登录</el-button>
					    <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
					  </el-form-item>
					</el-form>
				</div>
			</div>
		</div>

		<!-- <mainBottom></mainBottom> -->
	</div>
</template>
<script>
	import mainBottom from '../components/mainBottom.vue'
  import request from '@/utils/request'
  import Cookies from "js-cookie";
  import axios from 'axios'
  import { encrypt, decrypt } from '@/utils/jsencrypt'
  import vueQr from 'vue-qr'
  function getCodeImg() {
    return request({
      url: 'https://admin.nxhzy.cn/prod-api/captchaImage',
      headers: {
        isToken: false
      },
      method: 'get',
      timeout: 20000
    })
  }

  export default {
    name: "qecode",
	  components: {
		   mainBottom:() => import("../components/mainBottom.vue"),
      vueQr
    },
	   data(){
		   var validatePass = (rule, value, callback) => {
		           if (value === '') {
		             callback(new Error('请输入密码'));
		           } else {
					   if (value.length<6||value.length>20) {
					   	callback(new Error('请重新输入密码，密码不合规'));
					   	// return;
					   }else{
						   callback();
					   }
		            //  if (this.registerForm.checkPass !== '') {
		            //    this.$refs.registerForm.validateField('checkPass');
		            //  }

		           }
		         };
		         var validatePass2 = (rule, value, callback) => {
		           if (value === '') {
		             callback(new Error('请再次输入密码'));
		           } else if (value !== this.loginForm.password) {
		             callback(new Error('两次输入密码不一致!'));
		           } else {
		             callback();
		           }
		         };
		   return{
         codeUrl: "",
			   pageSize: 16,
			   totalCount: 1,
			   totalPageSize:1,
         timestamp:null,
			   pageInputNum: '',
         wechatQrCode:false,
         qrStatus:true,
         wechatAccessToken:'',
         miniQrCode:'',
			   currentPage: 1,
			   total:5,
			   typeOptions: [{
			             value: '选项1',
			             label: '展商'
			           }, {
			             value: '选项2',
			             label: '展位名'
			           }, {
			             value: '选项3',
			             label: '资讯'
			           }, ],
				searchType:'',
				 loginForm: {
           sessionId:'',
					 userName:'',
           password: '',
					 phoneNumber:'',
           sessionKey:''
				},

				rules: {
						  userName: [{
						    required: true,
						    message: "用户名不能为空",
						    trigger: "blur"
						  }],
				          password: [
				            { validator: validatePass, trigger: 'blur' }
				          ],
				          checkPass: [
				            { validator: validatePass2, trigger: 'blur' }
				          ],
				          phoneNumber: [{
				            required: true,
				            message: "手机号不能为空",
				            trigger: "blur"
				          }, {
				            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
				            message: "请输入正确的手机号码",
				            trigger: "blur"
				          }],
						  firmName: [{
						    required: true,
						    message: "企业名称不能为空",
						    trigger: "blur"
						  }],
						  email: [{
						    required: false,
						    // message: "电子信箱不能为空",
						    trigger: "blur"
						  }, {
						    validator: function(rule, value, callback) {
						  								if (!value) {
						  								   return callback();
						  								}
						      if (
						        /^\w{1,64}@[a-z0-9\-]{1,256}(\.[a-z]{2,6}){1,2}$/i.test(
						          value
						        ) == false
						      ) {
						        callback(new Error("邮箱格式错误"));
						      } else {
						  								callback()
						      }
						    },
						    trigger: "blur"
						  }]
				        }
			   };
			},
		created(){

      this.getCode();
      this.getCookie();
      // this.getMiniCode();
      // this.getAccessToken()
      this.generateTimestamp();
		},
		methods:{

      getCode() {

        getCodeImg().then(res => {
          this.captchaOnOff = res.captchaOnOff === undefined ? true : res.captchaOnOff;
          if (this.captchaOnOff) {
            this.codeUrl = "data:image/gif;base64," + res.img;
            this.loginForm.sessionKey = res.uuid;
          }
        });
      },
      getCookie() {
        const username = Cookies.get("username");
        const password = Cookies.get("password");
        const rememberMe = Cookies.get('rememberMe')
        this.loginForm = {
          userName: username === undefined ? this.loginForm.userName : username,
          password: password === undefined ? this.loginForm.password : decrypt(password),
          rememberMe: rememberMe === undefined ? false : Boolean(rememberMe)
        };
      },
      showWechatQrCode(status){
        this.wechatQrCode = status === true;
        // console.log(this.wechatQrCode)
      },
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange() {
			   this.contentPerPage.pn=this.currentPage;
			   contentList(this.contentPerPage).then(response => {
			           this.contentPerPageList = response.data;
			         });
			},
			changeFirstPage(){
				this.currentPage=1;
				this.handleCurrentChange();
			},
			changeLastPage(){
				this.currentPage=this.totalPageSize;
				this.handleCurrentChange();
			},
			getTotalPageSize(){
				this.totalPageSize=this.totalCount/this.pageSize
			},
			changePage(){
				this.currentPage=this.pageInputNum;
				this.handleCurrentChange();
			},
      getlunxunData () {
        this.timer = window.setInterval(() => {
          setTimeout(() => {
            this.getUserByUuid(this.timestamp)
          },0)
        },3000)
      },
      getUserByUuid (){
        axios.get('/web/audience/uuid/'+this.timestamp).then((res)=>{
          // console.log(res.data)
          if (res.data.data) {
            Cookies.set('username',res.data.data.userName)
            Cookies.set('sessionId',res.data.data.sessionId)
            this.$router.push({ path: '/site/index' })
            window.clearInterval(this.timer)
          }
          // console.log(this.timestamp);
          // this.getMiniCode();
        })


      },
      getMiniCode() {
        axios.post('https://api.weixin.qq.com/wxa/getwxacodeunlimit?access_token='+this.wechatAccessToken,{
          "page": "pages/index/index",
          "scene": "uuid="+this.timestamp,
          "check_path": true,
          "env_version": "develop"
        }).then((res)=>{
          this.miniQrCode=res.data
        })
      },
      generateTimestamp() {
        this.timestamp = Date.now();
        // this.timestamp = 1709719474212;
        this.miniQrCode = 'https://zh.heavenk.com/user_login_pc?uuid='+this.timestamp;
      },
      getAccessToken(){
        axios.get('/web/audience/accessToken').then((res)=>{
          this.wechatAccessToken=res.data
          this.generateTimestamp();
          // console.log(this.timestamp);
          // this.getMiniCode();
        })
      },
			async submitForm() {
				// if (!this.loginForm.checked) {
				// 	alert('请仔细阅读《用户服务协议》后勾选我已阅读并同意!');
				// 	return;
				// }
				// if (!this.loginForm.userName) {
				// 	alert('用户或者密码不能为空!');
				// 	return;
				// }
				// if (!this.loginForm.password) {
				// 	alert('用户或者密码不能为空!');
				// 	return;
				// }
				// if (!this.loginForm.phoneNumber) {
				// 	alert('手机号码不能为空!');
				// 	return;
				// }
				// if (!this.loginForm.firmName) {
				// 	alert('企业名称不能为空!');
				// 	return;
				// }
				// if (this.loginForm.password.length<6||this.loginForm.password.length>20) {
				// 	alert('请重新输入密码，密码不合规!');
				// 	return;
				// }
				// if (this.loginForm.password !== this.loginForm.checkPass) {
				// 	alert('两次输入密码不一致!');
				// 	return;
				// }
				try {
					const response = await axios.post('/web/audience/login', this.loginForm);
          // const response = await axios.post('/web/audience/login', this.loginForm);
					// 处理响应数据
					alert(response.data.msg);
               if (response.data.msg=='登录成功') {
                 Cookies.set('username',response.data.data.username)
                 Cookies.set('sessionId',response.data.data.sessionId)
                 window.clearInterval(this.timer)
                 this.$router.push({ path: '/site/index' })

               }
					// 可以根据需要更新组件状态或执行其他操作
				} catch (error) {
					// 处理错误
					console.error(error);
					  alert(error)
				}
			},
			resetForm(formName) {
			this.$refs[formName].resetFields();
			},
    },
		mounted(){
      this.getlunxunData();
      setTimeout(this.hideQRCode, 5 * 60 * 1000);
      // 在组件挂载后实例化 WxLogin 对象
      // var obj = new WxLogin({
      //   self_redirect: true,
      //   id: "login_container", // 登录按钮的容器 ID
      //   appid: "wxf74e29783316a3d8", // 你的应用 ID
      //   scope: "snsapi_login", // 授权范围，这里使用 snsapi_login
      //   redirect_uri: "https%3A%2F%2Fzh.heavenk.com%2Fwechat", // 授权后重定向的回调链接地址
      //   state: "STATE", // 重定向后会带上 state 参数，开发者可以填写 a-zA-Z0-9 的参数值，最多 128 字节
      //   style: "white", // 提供 "black"、"white" 可选，默认为 "white"
      //   href: "" // 外部链接，可选参数，非必填项。如果传入该参数，则点击二维码图片的链接将跳转至 href 的内容
      // });
    },
    destroyed() {
      window.clearInterval(this.timer)
    },

    hideQRCode() {
      this.qrStatus=false;
      window.clearInterval(this.timer);
    }
  }

</script>

<style>
	.register{
		width: 1140px;
		min-width: 1140px;
		height: 750px;
		margin: auto;
		margin-top: 33px;
		background-color: #fff;
	}
	.registerForm .el-form-item__label{
		color: #150e52;
		font-size: 23px;
		width: 180px !important;
		height: 57px;
		line-height: 57px;
	}
	.registerForm .el-input__inner{
		width: 500px;
		height: 57px;
		border: 2px solid #c5c3d4;
		border-radius: 0px !important;
		color: #150e52;
		font-size: 21px;
	}
	.registerForm .el-input{
		width: 500px;
		height: 57px;
		line-height: 57px;
	}
	.registerForm  .el-input__inner::placeholder {
	        color: #c5c3d4;
	    }
	     /* 谷歌 */
	    .registerForm  .el-input__inner::-webkit-input-placeholder {
	        color: #c5c3d4;
	    }
	     /* 火狐 */
	   .registerForm  .el-input__inner:-moz-placeholder {
	        color: #c5c3d4;
	    }
	     /*ie*/
	   .registerForm  .el-input__inner:-ms-input-placeholder {
	        color: #c5c3d4;
	    }
		.registerForm .el-checkbox__label{
			color: #150e52 !important;
			font-size: 23px;
		}
		.registerForm .el-checkbox__inner{
			    border: 2px solid #150e52;
			    width: 17px;
			    height: 17px;
			    top: -3px;
		}
		.registerForm .el-checkbox__input.is-checked .el-checkbox__inner{
			background-color: #150e52;
			border-color: #150e52;
		}
		.registerForm .el-checkbox__input.is-focus .el-checkbox__inner{
			/* background-color: #150e52; */
			border-color: #150e52;
		}
		.registerForm .el-button.el-button--default{
			color: #fff;
			background-color: #150e52;
			width: 390px;height: 65px;
			border-radius: 0px;
			font-size: 23px;
			margin-top: 24px;
		}
		.btn .el-form-item__content{
			margin-left: 0px !important;
		}
		.registerForm .el-form-item__error{
			margin-left: 81px;
		}
		.yhxy:hover{
			color: #c5c3d4 !important;
		}
		.registerForm .el-form-item--feedback .el-input__validateIcon,
		.registerForm .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before{
		    display: none;
		}
</style>
